import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "source", "sourceField", "toggle"]

  connect() {
    this.syncSourceFromEditor()
    this.hideSource()
  }

  toggle(event) {
    event.preventDefault()

    if (this.sourceTarget.hidden) {
      this.syncSourceFromEditor()
      this.showSource()
    } else {
      this.applySourceToEditor()
      this.hideSource()
    }
  }

  submit() {
    if (!this.sourceTarget.hidden) {
      this.applySourceToEditor()
    }
  }

  syncSourceFromEditor() {
    this.sourceFieldTarget.value = this.hiddenInput().value
  }

  applySourceToEditor() {
    const html = this.sourceFieldTarget.value
    this.hiddenInput().value = html
    this.editorTarget.editor.loadHTML(html)
  }

  hiddenInput() {
    const inputId = this.editorTarget.getAttribute("input")
    return this.element.querySelector(`#${inputId}`)
  }

  showSource() {
    this.sourceTarget.hidden = false
    this.toggleTarget.textContent = "Preview formatted"
  }

  hideSource() {
    this.sourceTarget.hidden = true
    this.toggleTarget.textContent = "Edit HTML"
  }
}
